import { REPLACE_VOUCHERS, CLEAR_VOUCHERS } from './actions';

const initialState = {
    vouchers: [],
    totalResults: 0,
    totalPage: 1
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE_VOUCHERS:
            return {
                ...state,
                vouchers: action.vouchers,
                totalResults: action.totalResults,
                totalPage: action.totalPage
            }
        case CLEAR_VOUCHERS:
            return initialState
        default:
            return state;
    }
}